import { Link } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";

const PreviousPageHeader = (props) => {
  return (
    <div className="bg-indigo-600 h-[63px] flex items-center">
      <Link to={props.previousPageLink}>
        <ChevronLeftIcon
          className="h-5 w-auto text-white pl-2 pr-3"
          aria-hidden="true"
        />
      </Link>
      <h2 className="font-bold leading-7 text-white text-xl tracking-tight">
        {props.pageTitle}
      </h2>
    </div>
  );
};

export default PreviousPageHeader;
